import { useMemo } from 'react';
import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums/location_feature_enum.pb';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { useFeatureSubscriptionConfig } from '@frontend/self-upgrade';

type UseIsCallIntelEligibleAccountParams = {
  includeAiReceptionist?: boolean;
  locationIds?: string[];
};

type UseIsCIEligibleAccount = {
  isCallIntelActive?: boolean;
  isCallIntelEligibleAccount?: boolean;
  activeLocationIds: string[];
  isLoading: boolean;
};

const FEATURE_ACTIVE_STATES = [State.ACTIVE, State.PROMOTE];

// This is used in the Analytics app to determine if the location is eligible for the call intel feature.
export const useIsCallIntelEligibleAccount = ({
  includeAiReceptionist = true,
  locationIds,
}: UseIsCallIntelEligibleAccountParams = {}): UseIsCIEligibleAccount => {
  const {
    isFeatureActiveInSomeLocations: isCallIntelFeatureActive,
    isUpgradeOrTrialEligible: isCallIntelUpgradeEligible,
    subscriptionDataList: callIntelSubscriptionData,
    isLoading: isCallIntelLoading,
  } = useFeatureSubscriptionConfig({
    activeStates: FEATURE_ACTIVE_STATES,
    checkBundleUpgrade: false,
    feature: Feature.CALL_INTELLIGENCE,
    locationIds,
  });

  //TODO: TO check only CF

  // const {
  //   isFeatureActiveInSomeLocations: isVoiceAiFeatureActive,
  //   subscriptionDataList: voiceAiSubscriptionData,
  //   isLoading: isVoiceAiLoading,
  // } = useFeatureSubscriptionConfig({
  //   activeStates: FEATURE_ACTIVE_STATES,
  //   checkBundleUpgrade: false,
  //   feature: Feature.TRUELARK_AI_VOICE,
  //   locationIds,
  // });

  const activeLocationIds = useMemo(() => {
    const callIntelLocations =
      callIntelSubscriptionData?.filter(({ isStateActive }) => isStateActive).map(({ locationId }) => locationId) || [];

    if (!includeAiReceptionist) {
      return callIntelLocations;
    }

    // const voiceAiLocations =
    //   voiceAiSubscriptionData?.filter(({ isStateActive }) => isStateActive).map(({ locationId }) => locationId) || [];

    const combinedLocationIds = [...callIntelLocations];
    return [...new Set(combinedLocationIds)];
  }, [callIntelSubscriptionData, includeAiReceptionist]);

  // const isCallIntelActive = !includeAiReceptionist ? isCallIntelFeatureActive : isCallIntelFeatureActive;

  const isCallIntelEligibleAccount = isCallIntelFeatureActive || isCallIntelUpgradeEligible;

  // const isLoading = !includeAiReceptionist ? isCallIntelLoading : isCallIntelLoading;

  return {
    isCallIntelActive: isCallIntelFeatureActive,
    isCallIntelEligibleAccount,
    activeLocationIds,
    isLoading: isCallIntelLoading,
  };
};
